<template>
  <el-select
    :placeholder="$t('COMMON.LOCALE')"
    v-model="localeModel"
    @change="localeChanged"
  >
    <el-option key="fr" value="fr" :label="$t('COMMON.LOCALE_FR')"> </el-option>
    <el-option key="en" value="en" :label="$t('COMMON.LOCALE_EN')"> </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "locale-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    locale: {
      type: String,
      default: null,
      description: "Default locale",
    },
  },

  data() {
    return {
      localeModel: this.locale,
      locales: {},
    };
  },

  setup() {},

  created() {},

  methods: {
    localeChanged(locale) {
      this.$emit("localeChanged", locale);
    },
  },

  watch: {
    locale(locale) {
      this.localeModel = locale;
    },
  },
};
</script>
